module.exports = __webpack_public_path__ + "assets/0.1.11/img/default.6b914f9c.jpg";